
import { defineComponent, ref, onMounted, computed, getCurrentInstance } from "vue-demi";
import axios from "@/plugins/http";
import { API_ROUTES } from "@/utils/API";
import {
  API_TCase,
  TTable_Services_Employee,
  convertServicesForTable,
} from "@/models/cases_employer";
import { API_TDependant } from "@/models/dependant";

import QuickActionsEmployee from "@/components/V2/QuickActions/QuickActionsEmployee.vue";
import { SMAdditionalInfo, SMCases } from "@/store";

export default defineComponent({
  name: "VEmployeeServices",

  components: {
    QuickActionsEmployee,
  },

  setup() {
    const router = getCurrentInstance()?.proxy?.$router;

    async function onServiceClick(item: TTable_Services_Employee) {
      if (!item.id) return;

      await router.push(`/cases/${item.id}/dashboard/${SMCases.tabId}`);
    }

    const headersDefault = [
      {
        label: "Service",
        value: "name",
        action: onServiceClick,
      },
      {
        label: "Step",
        value: "case_progress_step_name",
      },
      {
        label: "Final Decision",
        value: "final_decision",
      },
    ];

    const headersDependant = [
      {
        label: "Service",
        value: "name",
        action: onServiceClick,
      },
      {
        label: "Applicant Name",
        value: "applicant_name",
      },
      {
        label: "Step",
        value: "case_progress_step_name",
      },
      {
        label: "Final Decision",
        value: "final_decision",
      },
    ];

    const cases = ref<TTable_Services_Employee[]>([]);

    const sortedCases = computed(() => cases.value.sort((a, b) => a.progress - b.progress));

    const loading = ref(false);

    async function getTableCases() {
      const { data } = await axios.get<API_TCase[]>(API_ROUTES.CASE());

      if (!data) return;

      cases.value = data.map((a) => convertServicesForTable(a));
    }

    const dependantsList = computed<API_TDependant[]>(() => SMAdditionalInfo.dependantsList);

    const canStartDependantCase = computed<boolean>(() => SMAdditionalInfo.canStartDependantCase);

    const hasDependants = computed<boolean>(
      () => !!dependantsList.value.find((d) => !!d.case_created)
    );

    const headers = computed(() => (hasDependants.value ? headersDependant : headersDefault));

    onMounted(async () => {
      try {
        loading.value = true;

        // await Promise.all([getTableCases(), getDependantsList()]);

        await getTableCases();
      } finally {
        loading.value = false;
      }
    });

    return {
      headers,
      sortedCases,
      hasDependants,
      canStartDependantCase,
      dependantsList,
      loading,
    };
  },
});
